<template>
  <div class="row">
    <div class="col-xs-12 customersearch-item billingcustomer">
      <div class="panel panel-default" v-on:click="selectBillingcustomer" v-if="customer">
        <div :class="headingClass"><span>{{ customer.company }}</span><button class="btn btn-success btn-xs">{{ selected ? _('Deselect') : _('Select') }}</button></div>
        <div class="panel-body">
          <div class="row"> 
            <div class="col-md-6 col-xs-12">
              <template v-if="customer.ident">{{ _('Company id:') }} {{ customer.ident }}<br /></template>
              <template v-if="customer.email">{{ customer.email }}<br /></template>
              <template v-if="customer.phone">{{ customer.phone }}<br /></template>
              <a href="javascript:;" v-on:click.stop="editBillingCustomer">{{ _('Edit') }}</a>
            </div>
            <div class="col-md-6 col-xs-12" v-if="customer.sharedCustomer && customer.sharedCustomer.length">
              <h4>{{ _('Linked clients') }}</h4>
              <template v-for="c in sortedCustomers"><a href="javascript:;" v-on:click.stop="selectCustomers(c, customer)">{{ c.name }}</a><br /></template>
            </div>
            <div class="col-md-6 col-xs-12" v-if="false">
              <template v-if="customer.address">{{ customer.address }}<br /></template>
              <template v-if="customer.zip || customer.city">{{ customer.zip }} {{ customer.city}}<br /></template>
              <template v-if="customer.country">{{ customer.country }}</template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { BillingCustomerDetails } from '#components'
import modals from '~/lib/modals'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'customer', 'selected'],
  mixins: [modals],
  computed: {
    headingClass () {
      return 'panel-heading' + (this.selected ? ' panel-selected' : '')
    },
    sortedCustomers () {
      if (!this.customer || !this.customer.sharedCustomer || !this.customer.sharedCustomer.length) {
        return []
      }
      return [...this.customer.sharedCustomer].sort((a, b) => a.name > b.name ? 1 : -1)
    }
  },
  methods: {
    selectCustomers (customer, billingCustomer) {
      this.selectCustomer(customer)
      this.selectBillingcustomer(billingCustomer)
    },
    selectCustomer (customer) {
      this.$emit('selectCustomer', customer)
    },
    selectBillingcustomer (customer) {
      if (customer && customer.id) { // If we omit the customer parameter, vue sends the click event, so we must check for id
        this.$emit('selectBillingcustomer', customer)
      } else if (this.selected) {
        this.$emit('selectBillingcustomer', null)
      } else {
        this.$emit('selectBillingcustomer', this.customer)
      }
    },
    editBillingCustomer () {
      this.showModal('billingcustomerdetails', BillingCustomerDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              billingCustomer: this.customer,
              modal: true
            }
          }
        },
        events: {
          save: this.billingCustomerSaved
        },
        handlers: {},
        width: 1000
      })
    },
    billingCustomerSaved (customer) {
      // No need to do anything I guess?
    }
  },
  components: {
    BillingCustomerDetails
  }
}
</script>
